import {
    ACTION_GET_RESULTS_MONTHLY_CHART,
    ACTION_GET_RESULTS_WEEKLY_CHART,
    ACTION_GET_RESULTS_ANNUAL_CHART,
    ACTION_GET_RESULTS_HAPPINESS,
    ACTION_EMAIL_SEND_HAPINNES,
    SET_RESULTS_MONTHLY_CHART,
    SET_RESULTS_ANNUAL_CHART,
    SET_RESULTS_WEEKLY_CHART,
    SET_RESULTS_HAPPINESS
} from "@/views/chart/store/types/types.js";

import { HapinessService } from "../../../services";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

const actions = {

    [ACTION_GET_RESULTS_HAPPINESS]: ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            state.loading = true;

            const idGroup = sessionStorage.getItem("idGroup");
            const idEmpresa = sessionStorage.getItem("idEmpresa");
            const idUsuario = sessionStorage.getItem("idUsuario");

            HapinessService.getResultsHappiness( idGroup, idEmpresa, idUsuario )
            .then(async resp => {                    
                commit(SET_RESULTS_HAPPINESS, resp.data.payload);
                resolve(resp.data.payload)
            })
            .catch(err => {
                reject(err)
            })
            .finally(() => state.loading = false);
        })
    },

        
    [ACTION_GET_RESULTS_WEEKLY_CHART]: ({ state, commit }, payload ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                HapinessService.getResultsWeeklyChart(idGroup, companyId, userId, payload.startDate, payload.endDate)
                    .then(async resp => {
                        commit(SET_RESULTS_WEEKLY_CHART, resp.data.payload.windows);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_RESULTS_MONTHLY_CHART]: ({ state, commit }, payload ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                HapinessService.getResultsMonthlyChart(idGroup, companyId, userId, payload.monthDate)
                    .then(async resp => {
                        commit(SET_RESULTS_MONTHLY_CHART, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_RESULTS_ANNUAL_CHART]: ({ state, commit }, payload ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                HapinessService.getResultsAnnualChart(idGroup, companyId, userId, payload.yearDate)
                    .then(async resp => {
                        commit(SET_RESULTS_ANNUAL_CHART, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_EMAIL_SEND_HAPINNES]: ({ state }, data ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                let dataSend;
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                if (data.monthDate) {
                    data.startDate = null;
                    data.endDate = null;
                    dataSend = HapinessService.postEmailSendHapinnesMonthly(idGroup, companyId, userId, data)
                } else {
                    dataSend = HapinessService.postEmailSendHapinnesWeekly(idGroup, companyId, userId, data)
                }
                dataSend.then(async resp => {
                    const message = resp.status === 202 || !resp.data?.payload?.message
                        ? i18n.t('report.label.email.processing')
                        : resp.data.payload.message;
                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: message,
                        showConfirmButton: false,
                        timer: 2500
                    });
                    resolve(resp);
                })
                .catch(error => {
                    if (error.status === 202 || error?.response?.status === 202) {
                        const message = i18n.t('report.label.email.processing');
                        Swal.fire({
                            position: 'top-end',
                            icon: 'info',
                            title: message,
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(error);
                    } else {
                        reject(error);
                    }
                })
                .finally(() => {
                    state.loading = false;
                });
                
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },
}

export default actions;